// vuetifyのv-data-tableの列の幅の計算用
// 全体の比率の合計が100%にならないとレイアウトがくずれることから導入
// 行の表示非表示設定をもとに、チェックボックス列の幅は固定で、それ以外の列の幅を全体が100%になるように計算しなおす

function sumWidth<T extends string | number | symbol>(
    visibility: { [P in T]: boolean },
    ratio: { [P in T]: number }
): number {
    let visibleWidthSum = 0;
    for (const key in visibility) {
        if (visibility[key]) {
            visibleWidthSum += ratio[key];
        }
    }
    return visibleWidthSum;
}

// 全ての行を比率で処理する
class AllRelativeWidth<T extends string | number | symbol> {
    private selectColRatio: number;
    private colWidthRatio: { [P in T]: number };
    private colVisibility: { [P in T]: boolean };
    private totalWidthExceptSelect: number;

    constructor(selectColRatio: number, visibility: { [P in T]: boolean }, ratio: { [P in T]: number }) {
        this.selectColRatio = selectColRatio;
        this.colWidthRatio = ratio;
        this.colVisibility = visibility;
        this.totalWidthExceptSelect = sumWidth(visibility, ratio);
    }

    public calcColWidthPercentage(column: T): string {
        if (!this.colVisibility[column]) {
            return '0%';
        }

        const colRatio = (this.colWidthRatio[column] / this.totalWidthExceptSelect) * (1 - this.selectColRatio);

        return `${colRatio * 100}%`;
    }

    public selectColWidth(): string {
        return `${this.selectColRatio * 100}%`;
    }
}

// チェックボックス列は固定、他は比率で再計算
class SelectColFixed<T extends string | number | symbol> {
    private selectCol: string;
    private colWidthRatio: { [P in T]: number };
    private colVisibility: { [P in T]: boolean };
    private totalWidthExceptSelect: number;

    constructor(selectColWidth: string, visibility: { [P in T]: boolean }, ratio: { [P in T]: number }) {
        this.selectCol = selectColWidth;
        this.colWidthRatio = ratio;
        this.colVisibility = visibility;
        this.totalWidthExceptSelect = sumWidth(visibility, ratio);
    }

    public calcColWidthPercentage(column: T): string {
        if (!this.colVisibility[column]) {
            return '0%';
        }

        const colRatio = this.colWidthRatio[column] / this.totalWidthExceptSelect;

        return `${colRatio * 100}%`;
    }

    public selectColWidth(): string {
        return this.selectCol;
    }
}

export default class DataTableColumnWidthCalcurator<T extends string | number | symbol> {
    private delegated: AllRelativeWidth<T> | SelectColFixed<T>;

    constructor(selectCol: number | string, visibility: { [P in T]: boolean }, ratio: { [P in T]: number }) {
        if (typeof selectCol === 'number') {
            this.delegated = new AllRelativeWidth(selectCol, visibility, ratio);
        } else {
            this.delegated = new SelectColFixed(selectCol, visibility, ratio);
        }
    }

    public calcColWidthPercentage(column: T): string {
        return this.delegated.calcColWidthPercentage(column);
    }

    public selectColWidth(): string {
        return this.delegated.selectColWidth();
    }
}
